import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useContext, useState } from "react";

type PaywallMap = Record<string, boolean>;

type ContextValue = {
  paywallMap?: PaywallMap;
  setPaywallMap?: Dispatch<SetStateAction<PaywallMap>>;
};

const PaywallCheckerContext = createContext<ContextValue>({});

export type Props = {
  children?: ReactNode;
};

export const ArticlePaywallCheckerProvider: React.FunctionComponent<Props> = ({ children }) => {
  const [paywallMap, setPaywallMap] = useState<PaywallMap>({});

  return (
    <PaywallCheckerContext.Provider
      value={{
        paywallMap,
        setPaywallMap,
      }}
    >
      {children}
    </PaywallCheckerContext.Provider>
  );
};
ArticlePaywallCheckerProvider.displayName = "ArticlePaywallCheckerProvider";

export const usePaywallCheckerContext = () => useContext(PaywallCheckerContext);
